<template>
  <div>
    <qb-table>
      <template v-slot:thead>
        <qb-tr style="width: 100%">
          <qb-th class="f-14">
            {{ $t('client') | capitalize }}
          </qb-th>
          <qb-th class="f-14">
            {{ $t('start_date') | capitalize }}
          </qb-th>
          <qb-th class="f-14">
            {{ $t('position_title') | capitalize }}
          </qb-th>
          <qb-th class="f-14">
            {{ $tc('facility', 1) | capitalize }}
          </qb-th>
          <qb-th class="f-14">
            {{ $t('shift') | capitalize }}
          </qb-th>
          <qb-th class="text-center f-14">
            <feather-icon
              icon="UserIcon"
              svgClasses="h-5 w-5 hover:text-primary cursor-pointer action-block text-warning"
            />
          </qb-th>
          <qb-th class="text-center f-14">
            <feather-icon
              icon="XCircleIcon"
              svgClasses="h-5 w-5 hover:text-primary cursor-pointer action-block text-primary"
            />
          </qb-th>
          <qb-th class="text-center f-14">
            <feather-icon
              icon="CalendarIcon"
              svgClasses="h-5 w-5 hover:text-primary cursor-pointer action-block text text-info"
            />
          </qb-th>
          <qb-th class="text-center f-14">
            {{ $t('hired') | capitalize }} / {{ $t('required') | capitalize }}
          </qb-th>

          <qb-th class="f-14">
            {{ $t('aging') | capitalize }}
          </qb-th>
          <qb-th class="f-14">
            {{ $t('status') | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 10px"></qb-th>
        </qb-tr>
      </template>
      <template v-slot:tbody>
        <!-- <qb-tr v-for="(el, idx) in data" :key="idx"> -->
        <qb-tr v-for="(el, idx) in data" :key="idx">
          <qb-td>{{ el.ClientName | capitalize }}</qb-td>
          <qb-td>{{ formatDate(el.start_date)}}</qb-td>
          <qb-td>{{ el.Title_Name | capitalize }}</qb-td>
          <qb-td>{{ el.Facility | upperCase }}</qb-td>
          <qb-td>{{ el.Shift_Name | upperCase }}</qb-td>
          <qb-td class="text-center text-warning">
            {{ el.candidate | upperCase }}
          </qb-td>
          <qb-td class="text-center text-primary">
            {{ el.rejected | upperCase }}
          </qb-td>
          <qb-td class="text-center text-info">
            {{ el.interview | upperCase }}
          </qb-td>
          <qb-td class="text-center">
            {{ el.hired | upperCase }} / {{ el.vacancies | upperCase }}
          </qb-td>
          <qb-td >
            {{ el.aging | upperCase }}
          </qb-td>
          <qb-td class="text-center">
            <vs-chip :color="el.Status_Color" class="chip-status text-center w-full">
              {{ el.Status_Name | upperCase }}
            </vs-chip>
          </qb-td>
          <qb-td>
            <action-icon
              icon="SidebarIcon"
              :tooltip="$t('details') | capitalize"
              @click="showDetails(el.id)"
          /></qb-td>
        </qb-tr>
        <qb-tr>
          <qb-td colspan="100%">
            <div
              v-if="data.length"
              v-observe-visibility="infiniteHandler"
            ></div>
          </qb-td>
        </qb-tr>
      </template>
    </qb-table>
  </div>
</template>

<script>
import QbTable from '@/views/qb-components/table/QbTable.vue'
import QbTr from '@/views/qb-components/table/QbTr.vue'
import QbTh from '@/views/qb-components/table/QbTh.vue'
import QbTd from '@/views/qb-components/table/QbTd.vue'
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
export default {
  name: 'indirect-table',
  components: {
    ActionIcon,
    QbTable,
    QbTr,
    QbTh,
    QbTd,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getProgress(hired, required) {
      if(hired == 0 || required == 0 ){
        return 0
      }
      return (hired * 100) / required
    },
    showDetails(id) {
      this.$emit('showDetails', id)
    },
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
  },
}
</script>

<style>
.chip-status {
  max-width: 9rem;
  min-width: 2rem;
  color: white;
  text-align: center;
  border-radius: 0.3em;
}
</style>
